import NotificationSlice from "./Slice";

export { NotificationSlice };
